const HeaderStyleTwo = () => {
  return (
    <>
      <header className='main-header'>
        <div className='header-top'>
          <div className='auto-container'>
            <div className='inner clearfix'>
              <div className='top-left'>
                <ul className='social-links clearfix'>
                  <li className='social-title'>Follow Us:</li>
                  <li>
                    <a href='https://www.facebook.com/sejwf' target={'_blank'}>
                      <span className='fab fa-facebook-f'></span>
                    </a>
                  </li>
                  {/* <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                                    <li><a href="#"><span className="fab fa-linkedin-in"></span></a></li>
                                    <li><a href="#"><span className="fab fa-pinterest-p"></span></a></li> */}
                </ul>
              </div>

              <div className='top-right'>
                <ul className='info clearfix'>
                  <li>
                    <a href='tel:+923111172372'>
                      <span className='icon fa fa-phone-alt'></span> Call:
                      &nbsp; 03-11 -11 (SADQA) 72372
                    </a>
                  </li>
                  <li>
                    <a href='mailto:contact@sadqajariya.com'>
                      <span className='icon fa fa-envelope'></span> Email:
                      &nbsp; contact@sadqajariya.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className='header-upper'>
          <div className='auto-container'>
            <div className='inner-container clearfix'>
              <div className='logo-box'>
                <div className='logo'>
                  <a href='/' title=''>
                    <img src='../assets/images/logo.png' alt='' title='' />
                  </a>
                </div>
              </div>

              <div className='nav-outer clearfix'>
                <div className='mobile-nav-toggler'>
                  <span className='icon flaticon-menu-1'></span>
                </div>

                <nav className='main-menu navbar-expand-md navbar-light'>
                  <div
                    className='collapse navbar-collapse show clearfix'
                    id='navbarSupportedContent'
                  >
                    <ul className='navigation clearfix'>
                      <li className='current'>
                        <a href='/'>Home</a>
                      </li>
                      <li className='dropdown'>
                        <a href=''>About</a>
                        <ul>
                          <li>
                            <a href='/about'>About Us</a>
                          </li>
                          <li>
                            <a href='/founder-message'>Founder Message</a>
                          </li>
                          <li>
                            <a href='/our-team'>Our Team</a>
                          </li>
                          {/* <li><a href="/">Our Volunteers</a></li>
                                                        <li><a href="/">Faq's</a></li> */}
                        </ul>
                      </li>
                      <li className='dropdown'>
                        <a href=''>Programs</a>
                        <ul>
                          <li>
                            <a href='/sadaqah-udhiya-qurbani-obligations'>
                              Qurbani Obligations (2026)
                            </a>
                          </li>
                          {/* <li>
                            <a href='/relief-for-flood-victims-in-pakistan'>
                              Relief for Flood Victims in Pakistan
                            </a>
                          </li> */}
                          <li>
                            <a href='/free-grocery-for-widows-and-senior-citizen'>
                              Free Grocery for Widows and Senior Citizen
                            </a>
                          </li>
                          <li>
                            <a href='/apna-rozgar'>
                              Apna Rozgar (Small Business Setups)
                            </a>
                          </li>
                          <li>
                            <a href='/medical-support'>Free Medical Support</a>
                          </li>
                          <li>
                            <a href='/basic-schools'>
                              Free Education for Child (Basic Schools)
                            </a>
                          </li>
                          <li>
                            <a href='/water-hand-pumps'>
                              Clean Water Program (Water Hand Pumps)
                            </a>
                          </li>
                        </ul>
                      </li>
                      {/* <li>
                        <a
                          href='../assets/files/projects-2022-24.pdf'
                          target='_blank'
                        >
                          Projects
                        </a>
                      </li>  */}
                      {/* <li className='dropdown'>
                        <a href=''>Projects</a>
                        <ul> */}
                      {/* <li>
                            <a href='/projects/financial-monthly-support'>
                              Financial Monthly Support (Kifalat Program)
                            </a>
                          </li> */}
                      {/* <li>
                            <a href='/projects/monthly-ration-support'>
                              Monthly Ration Support
                            </a>
                          </li> */}
                      {/* <li>
                            <a href='/projects/small-business-program'>
                              Small Business Program
                            </a>
                          </li> */}
                      {/* <li>
                            <a href='/projects/technical-center-for-empowering-women'>
                              Technical Center For Empowering Women
                            </a>
                          </li> */}
                      {/* <li>
                            <a href='/projects/education-program'>
                              Education Program
                            </a>
                          </li> */}
                      {/* <li>
                            <a href='/projects/medical-program'>
                              Medical Program
                            </a>
                          </li> */}
                      {/* <li>
                            <a href='/projects/clean-water-projects'>
                              Clean Water Projects
                            </a>
                          </li> */}
                      {/* </ul>
                      </li> */}
                      <li className='dropdown'>
                        <a href=''>Gallery</a>
                        <ul>
                          <li>
                            <a href='/videos'>Videos</a>
                          </li>
                        </ul>
                      </li>
                      <li className='dropdown'>
                        <a href=''>Blog</a>
                        <ul>
                          <li>
                            <a href='/helping-an-orphan'>Helping An Orphan</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </nav>

                <div className='link-box clearfix'>
                  <div className='donate-link'>
                    <a href='/get-involved' className='theme-btn btn-style-one'>
                      <span className='btn-title'>Donate</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='sticky-header'>
          <div className='auto-container clearfix'>
            {/* <div className="logo pull-left">
                            <a href="/" title=""><img src="images/sticky-logo-3.png" alt="" title="" /></a>
                        </div> */}
            <div>
              <nav className='main-menu clearfix'>
                {/* <!--Keep This Empty / Menu will come through Javascript--> */}
              </nav>
            </div>
          </div>
        </div>
        <div className='mobile-menu'>
          <div className='menu-backdrop'></div>
          <div className='close-btn'>
            <span className='icon flaticon-cancel'></span>
          </div>

          <nav className='menu-box'>
            <div className='nav-logo'>
              <a href='/'>
                <img src='../assets/images/logo.png' alt='' title='' />
              </a>
            </div>

            <div className='menu-outer'></div>

            <div className='social-links'>
              <ul className='clearfix'>
                {/* <li><a href="#"><span className="fab fa-twitter"></span></a></li> */}
                <li>
                  <a href='https://www.facebook.com/sejwf' target={'_blank'}>
                    <span className='fab fa-facebook-square'></span>
                  </a>
                </li>
                {/* <li><a href="#"><span className="fab fa-pinterest-p"></span></a></li>
                                <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                                <li><a href="#"><span className="fab fa-youtube"></span></a></li> */}
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default HeaderStyleTwo;
